import { render, staticRenderFns } from "./PmAkademiCard.vue?vue&type=template&id=8089c522&scoped=true&"
import script from "./PmAkademiCard.vue?vue&type=script&lang=js&"
export * from "./PmAkademiCard.vue?vue&type=script&lang=js&"
import style0 from "./PmAkademiCard.vue?vue&type=style&index=0&id=8089c522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8089c522",
  null
  
)

export default component.exports